<template>
  <div
    id="kt_header"
    class="kt-header kt-grid__item kt-header--fixed"
    data-ktheader-minimize="on"
  >
    <div class="kt-header__bottom">
      <div class="gradient-bar"></div>
      <div class="kt-container m-auto" v-if="has_dealer">
        <!-- Open button -->
        <div class="open-button-container">
          <button
            v-if="!isNavbarVisible"
            class="kt-header-menu-wrapper-close"
            :class="{ close: isNavbarVisible }"
            id="kt_header_menu_mobile_open_btn"
            @click="toggleNavbarView(true)"
          >
            <p>Menu</p>
            <div class="lines-container">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </button>
        </div>

        <!-- Gameplan logo for mobile -->
        <figure>
          <router-link :to="'/dashboard'">
            <img
              class="gamemplan-logo-mobile"
              src="/images/logo.svg"
              alt="Gameplan Logo"
            />
          </router-link>
        </figure>

        <!-- List of links and Close button -->
        <div
          class="kt-header-menu-wrapper"
          :class="{ visible: isNavbarVisible }"
          id="kt_header_menu_wrapper"
        >
          <div id="kt_header_menu" class="kt-header-menu kt-header-menu-mobile">
            <!-- Close button -->
            <button
              class="kt-header-menu-wrapper-close close"
              id="kt_header_menu_mobile_close_btn"
              @click="toggleNavbarView(true)"
            >
              <i class="la la-close"></i>
            </button>

            <!-- Links -->
            <ul class="kt-menu__nav">
              <HeaderMenuItem
                v-for="(item, index) in menu_items"
                :key="index"
                :title="item.title"
                :link="item.link"
                :params="item.params"
                :sup="item.sup"
                :type="item.type"
                @click-item="toggleNavbarView"
              />
            </ul>
          </div>
        </div>

        <!-- end: Header Menu -->
      </div>
    </div>
  </div>
</template>

<script>
import HeaderMenuItem from "@/components/Dashboard/Header/HeaderMenuItem.vue";

export default {
  name: "HeaderMenu",
  props: ["has_dealer"],
  data() {
    return {
      menu_items: [
        { title: "Get Started", link: "/dashboard/" },
        { title: "FAQ", link: "/dashboard/FAQ" },
        //{ title: "How It Works", link: "/dashboard/"},
        { title: "My Settings", link: "/dashboard/settings" },
        //{ title: "Sales Rep", link: "sales_reps"},
        {
          title: "My Playbooks",
          link: "/dashboard/projects/playbook",
        },
        {
          title: "My Snapsheets",
          link: "/dashboard/projects/snapsheet",
        },
        { title: "My Messages", link: "/dashboard/quotes" },
        {
          title: "Create Playbook",
          link: "/dashboard/create_project/playbook",
          type: "button",
        },
        {
          title: "Create Snapsheet",
          link: "/dashboard/create_project/snapsheet",
          type: "button",
        },
      ],
      selectedNewProject: null,
      projectOpts: ["snapsheet", "instant playbook"],
      isNavbarVisible: false,
    };
  },
  methods: {
    toggleNavbarView(comesFromButton = false) {
      if (this.isNavbarVisible || comesFromButton) {
        this.isNavbarVisible = !this.isNavbarVisible;
      }
    },

    async TESThandleCreateNewProject() {
      try {
        if (this.projectOpts.find((p) => p === this.selectedNewProject)) {
          switch (this.selectedNewProject) {
            case "snapsheet":
              this.$router.push({
                path: "/dashboard/create_project/snapsheet",
              });
              break;
            case "instant playbook":
              this.$router.push("/dashboard/create_project/playbook");
              break;
            default:
              console.log("Select the type of project to create");
              break;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  components: {
    HeaderMenuItem,
  },
  computed: {
    actual_route() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
#kt_header {
  #test-create-project {
    position: absolute;
    left: 15px;
    top: 20px;
    width: 250px;
    display: flex;
    justify-content: space-evenly;
    background: white;
    align-items: center;
    padding: 2px 10px;
  }
  .kt-header__bottom {
    background-color: black;
    display: flex;
    flex-flow: column;
    .gradient-bar {
      background-image: url("/images/gradient-bar.png");
      background-repeat: no-repeat;
      background-size: cover;
      height: 3px;
      width: 100%;
      -moz-transform: scaleX(-1);
      -o-transform: scaleX(-1);
      -webkit-transform: scaleX(-1);
      transform: scaleX(-1);
      -ms-filter: "FlipH";
      filter: FlipH;
    }

    .kt-header-menu-wrapper {
      background-color: unset;
      padding: 0;
      display: flex;
      justify-content: center;
      &.visible {
        left: 0;
      }
      .showroom-logo {
        width: 200px;
        cursor: pointer;
      }
      .kt-menu__nav {
        @media screen and (max-width: 1024px) {
          padding: 20px 0 30px 0;
        }
        .kt-menu__item {
          &:hover {
            ::v-deep.kt-menu__link {
              @media screen and (max-width: 1024px) {
                span {
                  color: black;
                }
              }
            }
          }
          ::v-deep.kt-menu__link {
            @media screen and (max-width: 1500px) {
              padding: 0;
            }

            @media only screen and (min-width: 1024px) {
              border-right: 2px solid #fff;
            }
            border-radius: 0;
            padding: 0 20px;
            @media only screen and (max-width: 1500px) {
              padding: 0 12px;
            }
            @media only screen and (max-width: 1280px) {
              padding: 0 5px;
            }
            span {
              color: white;
              @media only screen and (max-width: 1280px) {
                font-size: 12px;
              }
            }
            .kt-menu__link-text {
              font-family: "ForzaBold";

              @media screen and (max-width: 1024px) {
                display: block;
                text-align: center;
                height: 50%;
                margin: auto;
              }
            }
          }
          /* &:last-child {
            ::v-deep.kt-menu__link {
              margin-left: 1rem;
            }
          } */
          &.kt-menu__item--open {
            ::v-deep.kt-menu__link {
              background-color: unset;
              @media screen and (max-width: 1024px) {
                &,
                &:hover {
                  background-color: white;
                  color: black !important;
                  span.kt-menu__link-text {
                    color: black !important;
                  }
                }
              }

              span {
                @media screen and (min-width: 1025px) {
                  padding-top: 1px;
                  border-bottom: 1px solid white;
                }
              }
            }
          }
        }

        ::v-deep .btn-project {
          color: white;
          border-radius: 6px !important;
          border: 2px solid white;
          padding: 0.5rem !important;
          margin: 0 0.5rem;
          &:hover {
            background: white;
            span {
              color: $dark;
            }
          }

          @media screen and (max-width: 1024px) {
            margin: 1rem;
          }
        }
      }
      .kt-header-toolbar {
        padding: 0;
        .btn {
          padding: 10px 20px;
          font-family: "ForzaBold";
          font-size: 12px;
          font-weight: normal;
          text-transform: uppercase;
          @media only screen and (max-width: 1280px) {
            padding: 10px;
          }
        }
      }

      @media screen and (max-width: 1024px) {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 0;
        height: 100vh;
        background-color: black;
      }
    }
  }
}

.header-menu-form {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

figure {
  display: flex;
  height: 100%;
  width: 35%;
  justify-content: center;
  align-items: center;
  margin: 0;
  .gamemplan-logo-mobile {
    display: block;
    width: 240px;
    margin: auto;
  }
}

#create-project-desktop-button {
  display: none;
  @media screen and (min-width: 1025px) {
    display: block;
  }
}

#create-project-mobile-button {
  display: none;
}

#create-project-desktop-button,
#create-project-mobile-button {
  background: transparent;
  /* font-family: "SlateStd" !important; */
  border: 2px solid white;
  text-transform: capitalize !important;
  border-radius: 3px;

  &:hover {
    background: white;
    color: black;
  }
}

@media screen and (max-width: 1024px) {
  .kt-container {
    width: 100vw;
    height: 50px;
    /* background-color: red; */
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  #kt_header_menu_mobile_open_btn,
  #kt_header_menu_mobile_close_btn {
    display: flex;
    /* flex-direction: column; */
    justify-content: space-between;
    width: 40px;
    height: 40px;
    position: initial;
    top: 0;
    top: 1px;
    left: 1rem;
    background: black;
    border: 1px solid white;
    z-index: 1002;
    transition: left 0.3s ease, right 0.3s ease;
    /* position: fixed; */
    border: 0;
    box-shadow: none;
    border-radius: 3px;
    cursor: pointer;
    outline: none !important;

    padding: 15px;

    &.close {
      background: red;
      justify-content: center;
      opacity: 1;
      i.la.la-close {
        color: white;
      }
    }

    .line {
      width: 15px;
      height: 2px;
      background-color: white;
    }
  }

  .open-button-container {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    #kt_header_menu_mobile_open_btn {
      position: relative;
      width: 30%;
      padding: 15px 0;
      font-family: Forza;
      margin: initial;
      p {
        color: white;
        margin: 0;
        margin-right: 0.7rem;
        font-family: "ForzaBold";
        text-transform: uppercase;
      }
      .lines-container {
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        height: 100%;
      }
    }
  }

  figure {
    display: flex;
    height: 100%;
    width: 50%;
    justify-content: center;
    align-items: center;
    margin: 0;
    .gamemplan-logo-mobile {
      display: block;
      min-width: 145px;

      @media screen and (max-width: 576px) {
        width: 145px;
      }
      margin: auto;
    }
  }

  #create-project-mobile-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20%;
    height: 75%;
  }
  .header-menu-form {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  #kt_header_menu {
    background-color: black;
    @media screen and (max-width: 1024px) {
      display: flex;
      flex-direction: column;
      #kt_header_menu_mobile_close_btn {
        margin-left: 15px;
        margin-top: 10px;
      }
    }
  }

  li.kt-menu__item.kt-menu__item--rel {
    display: flex;
    border-bottom: 1px solid grey;
    justify-content: center;
    align-items: center;
    flex-flow: row;

    a {
      span {
        display: block;
        text-align: center;
        height: 50%;
        margin: auto;
      }
    }
  }
}
</style>